import React, { useState, Fragment } from 'react';

import { SelectPowerDropdown, BoxesQuantityDropdown } from './Dropdown';
import { SelectPowerModal, BoxesQuantityModal } from './Modal';
import { USED_POWER } from '../../mockupConstants';
import './ContactLensSelectPowerAndBoxes.scss';

const CONTACT_LENS_POWER_AND_BOXES_LIST = [
  {
    key: 'use-saved-power',
    title: 'Use Saved Power',
  },
  {
    key: 'enter-power-manually',
    title: 'Enter Power Manually',
  },
  {
    key: 'i-will-submit-power-later',
    title: 'I Will Submit Power Later',
  },
];

export const ContactLensSelectPowerAndBoxes = props => {
  const { hasWithOrWithoutPower } = props;

  const [selectedPower, setSelectedPower] = useState(null);
  const [selectedUsedPower, setSelectedUsedPower] = useState(USED_POWER[0].id);
  const [selectedPowerManually, setSelectedPowerManually] = useState({
    left: {
      power: null,
      quantity: null,
    },
    right: {
      power: null,
      quantity: null,
    },
    isSamePower: false,
  });
  const [selectedSubmitLater, setSelectedSubmitLater] = useState({
    left: {
      power: null,
      quantity: null,
    },
    right: {
      power: null,
      quantity: null,
    },
    isSamePower: false,
  });
  const [selectedWithoutPower, setSelectedWithoutPower] = useState({
    left: {
      power: null,
      quantity: null,
    },
    right: {
      power: null,
      quantity: null,
    },
    isSamePower: false,
  });
  const [selectedWithOrWithoutPower, setSelectedWithOrWithoutPower] = useState('with-power');
  const [stateBoxesQuantity, setStateBoxesQuantity] = useState({
    isOpenManuallyLeft: false,
    isOpenManuallyRight: false,
    isOpenManuallyBoth: false,
    isOpenWithoutPowerLeft: false,
    isOpenWithoutPowerRight: false,
    isOpenWithoutPowerBoth: false,
    isOpenSubmitLaterLeft: false,
    isOpenSubmitLaterRight: false,
    isOpenSubmitLaterBoth: false,
    eye: null,
  });
  const [stateSelectPower, setStateSelectPower] = useState({
    isOpenLeft: false,
    isOpenRight: false,
    isOpenBoth: false,
    eye: null,
  });

  const SELECT_POWER_CONFIGS = [
    {
      key: 'left',
      isOpen: stateSelectPower.isOpenManuallyLeft,
      value: selectedPowerManually.left.power,
      eye: 'Left',
      onClose: () => setStateSelectPower({ isOpenManuallyLeft: false, eye: null }),
      onSelect: value =>
        setSelectedPowerManually(prev => ({
          ...prev,
          left: {
            ...prev.left,
            power: value,
          },
        })),
    },
    {
      key: 'right',
      isOpen: stateSelectPower.isOpenManuallyRight,
      value: selectedPowerManually.right.power,
      eye: 'Right',
      onClose: () => setStateSelectPower({ isOpenManuallyRight: false, eye: null }),
      onSelect: value =>
        setSelectedPowerManually(prev => ({
          ...prev,
          right: {
            ...prev.right,
            power: value,
          },
        })),
    },
    {
      key: 'both',
      isOpen: stateSelectPower.isOpenManuallyBoth,
      value:
        selectedPowerManually.left.power === selectedPowerManually.right.power
          ? selectedPowerManually.left.power
          : null,
      eye: 'Both',
      onClose: () => setStateSelectPower({ isOpenManuallyBoth: false, eye: null }),
      onSelect: value =>
        setSelectedPowerManually(prev => ({
          ...prev,
          left: { ...prev.left, power: value },
          right: { ...prev.right, power: value },
        })),
    },
  ];

  const BOXES_QUANTITY_CONFIGS = [
    {
      key: 'manually-left',
      isOpen: stateBoxesQuantity.isOpenManuallyLeft,
      value: selectedPowerManually.left.quantity,
      eye: 'Left',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenManuallyLeft: false, eye: null }),
      onSelect: value =>
        setSelectedPowerManually(prev => ({
          ...prev,
          left: {
            ...prev.left,
            quantity: value,
          },
        })),
    },
    {
      key: 'manually-right',
      isOpen: stateBoxesQuantity.isOpenManuallyRight,
      value: selectedPowerManually.right.quantity,
      eye: 'Right',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenManuallyRight: false, eye: null }),
      onSelect: value =>
        setSelectedPowerManually(prev => ({
          ...prev,
          right: {
            ...prev.right,
            quantity: value,
          },
        })),
    },
    {
      key: 'manually-both',
      isOpen: stateBoxesQuantity.isOpenManuallyBoth,
      value: selectedPowerManually.left.quantity,
      eye: 'Both',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenManuallyBoth: false, eye: null }),
      onSelect: value =>
        setSelectedPowerManually(prev => ({
          ...prev,
          left: { ...prev.left, quantity: value },
          right: { ...prev.right, quantity: value },
        })),
    },
    {
      key: 'without-left',
      isOpen: stateBoxesQuantity.isOpenWithoutPowerLeft,
      value: selectedWithoutPower.left.quantity,
      eye: 'Left',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenWithoutPowerLeft: false, eye: null }),
      onSelect: value =>
        setSelectedWithoutPower(prev => ({
          ...prev,
          left: { ...prev.left, quantity: value },
        })),
    },
    {
      key: 'without-right',
      isOpen: stateBoxesQuantity.isOpenWithoutPowerRight,
      value: selectedWithoutPower.right.quantity,
      eye: 'Right',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenWithoutPowerRight: false, eye: null }),
      onSelect: value =>
        setSelectedWithoutPower(prev => ({
          ...prev,
          right: { ...prev.right, quantity: value },
        })),
    },
    {
      key: 'without-both',
      isOpen: stateBoxesQuantity.isOpenWithoutPowerBoth,
      value: selectedWithoutPower.left.quantity,
      eye: 'Both',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenWithoutPowerBoth: false, eye: null }),
      onSelect: value =>
        setSelectedWithoutPower(prev => ({
          ...prev,
          left: { ...prev.left, quantity: value },
          right: { ...prev.right, quantity: value },
        })),
    },
    {
      key: 'submit-later-left',
      isOpen: stateBoxesQuantity.isOpenSubmitLaterLeft,
      value: selectedSubmitLater.left.quantity,
      eye: 'Left',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenSubmitLaterLeft: false, eye: null }),
      onSelect: value =>
        setSelectedSubmitLater(prev => ({
          ...prev,
          left: { ...prev.left, quantity: value },
        })),
    },
    {
      key: 'submit-later-right',
      isOpen: stateBoxesQuantity.isOpenSubmitLaterRight,
      value: selectedSubmitLater.right.quantity,
      eye: 'Left',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenSubmitLaterRight: false, eye: null }),
      onSelect: value =>
        setSelectedSubmitLater(prev => ({
          ...prev,
          right: { ...prev.right, quantity: value },
        })),
    },
    {
      key: 'submit-later-both',
      isOpen: stateBoxesQuantity.isOpenSubmitLaterBoth,
      value: selectedSubmitLater.left.quantity,
      eye: 'Left',
      onClose: () =>
        setStateBoxesQuantity({ ...stateBoxesQuantity, isOpenSubmitLaterBoth: false, eye: null }),
      onSelect: value =>
        setSelectedSubmitLater(prev => ({
          ...prev,
          left: { ...prev.left, quantity: value },
          right: { ...prev.right, quantity: value },
        })),
    },
  ];

  const renderPowerList = () => {
    return (
      <Fragment>
        <ul className="contact-lens-select-power-and-boxes__power__list">
          {USED_POWER.map(({ id, title, list, startDate, endDate }, i) => {
            const isExpired = i === 2;

            return (
              <li key={id} className="contact-lens-select-power-and-boxes__power__item">
                <div
                  className="contact-lens-select-power-and-boxes__power__item-box"
                  data-is-expired={isExpired}
                  onClick={() => setSelectedUsedPower(id)}
                >
                  <div
                    className="contact-lens-select-power-and-boxes__power__item-title"
                    data-is-expired={isExpired}
                    data-selected={selectedUsedPower === id}
                  >
                    <span>{title}</span>
                  </div>

                  {list?.map(({ powerType, left, right }) => (
                    <div
                      key={powerType}
                      className="contact-lens-select-power-and-boxes__power__item-value"
                    >
                      <div className="contact-lens-select-power-and-boxes__power__item-value__header">
                        <span>Type</span>
                        <span>Left Eye</span>
                        <span>Right Eye</span>
                      </div>

                      <div className="contact-lens-select-power-and-boxes__power__item-value__result">
                        <span>{powerType}</span>
                        <span>{left}</span>
                        <span>{right}</span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="contact-lens-select-power-and-boxes__power__item-date">
                  <p>Valid through: {startDate}</p>
                  <p>Uploaded on: {endDate}</p>
                </div>
              </li>
            );
          })}
        </ul>

        <div className="contact-lens-select-power-and-boxes__power__no-power">
          <p>
            You don’t have a power saved currently, you can book a free eye test after placing the
            order.
          </p>
          <p>Kindly select from other two available options</p>
        </div>

        <div className="contact-lens-select-power-and-boxes__power__need-to-login">
          <p>You are not logged in right now. Login to see your saved powers</p>

          <a href="/sg/en/customer/account/login">Login/ Signup</a>
        </div>
      </Fragment>
    );
  };

  const renderPowerManuallySameLeftAndRightEyes = () => {
    return (
      <div>
        <p
          className="contact-lens-select-power-and-boxes__power-manually__title"
          data-key="left-and-right-eyes"
        >
          Left & Right Eye
        </p>

        <div
          className="contact-lens-select-power-and-boxes__power-manually__button"
          data-button-type="power"
          onClick={() => setStateSelectPower({ isOpenManuallyBoth: true, eye: 'Left & Right' })}
        >
          <span>
            {selectedPowerManually.left.power &&
            selectedPowerManually.right.power &&
            selectedPowerManually.left.power === selectedPowerManually.right.power
              ? selectedPowerManually.left.power
              : 'POWER'}
          </span>

          <SelectPowerDropdown {...SELECT_POWER_CONFIGS.find(config => config.key === 'both')} />
        </div>

        <div
          className="contact-lens-select-power-and-boxes__power-manually__button"
          data-button-type="quantity"
          onClick={() => setStateBoxesQuantity({ isOpenManuallyBoth: true, eye: 'Left & Right' })}
        >
          <span>
            {selectedPowerManually.left.quantity &&
            selectedPowerManually.right.quantity &&
            selectedPowerManually.left.quantity === selectedPowerManually.right.quantity
              ? selectedPowerManually.left.quantity
              : 'SELECT QUANTITY'}
          </span>

          <BoxesQuantityDropdown
            {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'manually-both')}
          />
        </div>
      </div>
    );
  };

  const renderPowerManuallyEyes = () => {
    return (
      <>
        <div>
          <p className="contact-lens-select-power-and-boxes__power-manually__title">Left Eye</p>
          <div
            className="contact-lens-select-power-and-boxes__power-manually__button"
            data-button-type="power"
            onClick={() => setStateSelectPower({ isOpenManuallyLeft: true, eye: 'Left' })}
          >
            <span>{selectedPowerManually.left.power || 'POWER'}</span>

            <SelectPowerDropdown {...SELECT_POWER_CONFIGS.find(config => config.key === 'left')} />
          </div>

          <div
            className="contact-lens-select-power-and-boxes__power-manually__button"
            data-button-type="quantity"
            onClick={() => setStateBoxesQuantity({ isOpenManuallyLeft: true, eye: 'Left' })}
          >
            <span>{selectedPowerManually.left.quantity || 'QUANTITY'}</span>

            <BoxesQuantityDropdown
              {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'manually-left')}
            />
          </div>
        </div>

        <div>
          <p
            className="contact-lens-select-power-and-boxes__power-manually__title"
            data-key="right-eye"
          >
            Right Eye
          </p>

          <div
            className="contact-lens-select-power-and-boxes__power-manually__button"
            data-button-type="power"
            onClick={() => setStateSelectPower({ isOpenManuallyRight: true, eye: 'Right' })}
          >
            <span>{selectedPowerManually.right.power || 'POWER'}</span>

            <SelectPowerDropdown {...SELECT_POWER_CONFIGS.find(config => config.key === 'right')} />
          </div>

          <div
            className="contact-lens-select-power-and-boxes__power-manually__button"
            data-button-type="quantity"
            onClick={() => setStateBoxesQuantity({ isOpenManuallyRight: true, eye: 'Right' })}
          >
            <span>{selectedPowerManually.right.quantity || 'QUANTITY'}</span>

            <BoxesQuantityDropdown
              {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'manually-right')}
            />
          </div>
        </div>
      </>
    );
  };

  const renderPowerManually = () => {
    const isSamePower = selectedPowerManually.isSamePower;

    return (
      <div className="contact-lens-select-power-and-boxes__power-manually">
        <div
          className="contact-lens-select-power-and-boxes__power-manually__container"
          data-is-same-power={isSamePower}
        >
          {isSamePower ? renderPowerManuallySameLeftAndRightEyes() : renderPowerManuallyEyes()}
        </div>

        <div className="contact-lens-select-power-and-boxes__power-manually__same-power">
          <span
            data-is-checked={isSamePower}
            onClick={() =>
              setSelectedPowerManually({
                ...selectedPowerManually,
                isSamePower: !isSamePower,
              })
            }
          />
          <p>Same power and boxes for both eyes</p>
        </div>
      </div>
    );
  };

  const renderSameLeftAndRightEyes = key => {
    let titleValue = 'SELECT QUANTITY';

    if (key === 'submit-later') {
      if (
        selectedSubmitLater.left.quantity &&
        selectedSubmitLater.right.quantity &&
        selectedSubmitLater.left.quantity === selectedSubmitLater.right.quantity
      ) {
        titleValue = selectedSubmitLater.left.quantity;
      }
    }

    if (key === 'without-power') {
      if (
        selectedWithoutPower.left.quantity &&
        selectedWithoutPower.right.quantity &&
        selectedWithoutPower.left.quantity === selectedWithoutPower.right.quantity
      ) {
        titleValue = selectedWithoutPower.left.quantity;
      }
    }

    return (
      <div>
        <p
          className="contact-lens-select-power-and-boxes__power-manually__title"
          data-key="left-and-right-eyes"
        >
          Left & Right Eye
        </p>

        <div
          className="contact-lens-select-power-and-boxes__power-manually__button"
          data-button-type="quantity"
          onClick={() => {
            if (key === 'submit-later') {
              setStateBoxesQuantity({ isOpenSubmitLaterBoth: true, eye: 'Left & Right' });
            }

            if (key === 'without-power') {
              setStateBoxesQuantity({ isOpenWithoutPowerBoth: true, eye: 'Left & Right' });
            }
          }}
        >
          <span>{titleValue}</span>

          {key === 'submit-later' && (
            <BoxesQuantityDropdown
              {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'submit-later-both')}
            />
          )}

          {key === 'without-power' && (
            <BoxesQuantityDropdown
              {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'without-both')}
            />
          )}
        </div>
      </div>
    );
  };

  const renderEyes = key => {
    let titleValueLeft = 'QUANTITY';
    let titleValueRight = 'QUANTITY';

    if (key === 'submit-later') {
      titleValueLeft = selectedSubmitLater.left.quantity;
      titleValueRight = selectedSubmitLater.right.quantity;
    }

    if (key === 'without-power') {
      titleValueLeft = selectedWithoutPower.left.quantity;
      titleValueRight = selectedWithoutPower.right.quantity;
    }

    return (
      <>
        <div>
          <p className="contact-lens-select-power-and-boxes__power-manually__title">Left Eye</p>
          <div
            className="contact-lens-select-power-and-boxes__power-manually__button"
            data-button-type="quantity"
            onClick={() => {
              if (key === 'submit-later') {
                setStateBoxesQuantity({ isOpenSubmitLaterLeft: true, eye: 'Left' });
              }

              if (key === 'without-power') {
                setStateBoxesQuantity({ isOpenWithoutPowerLeft: true, eye: 'Left' });
              }
            }}
          >
            <span>{titleValueLeft || 'QUANTITY'}</span>

            {key === 'submit-later' && (
              <BoxesQuantityDropdown
                {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'submit-later-left')}
              />
            )}

            {key === 'without-power' && (
              <BoxesQuantityDropdown
                {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'without-left')}
              />
            )}
          </div>
        </div>

        <div>
          <p
            className="contact-lens-select-power-and-boxes__power-manually__title"
            data-key="right-eye"
          >
            Right Eye
          </p>
          <div
            className="contact-lens-select-power-and-boxes__power-manually__button"
            data-button-type="quantity"
            onClick={() => {
              if (key === 'submit-later') {
                setStateBoxesQuantity({ isOpenSubmitLaterRight: true, eye: 'Right' });
              }

              if (key === 'without-power') {
                setStateBoxesQuantity({ isOpenWithoutPowerRight: true, eye: 'Right' });
              }
            }}
          >
            <span>{titleValueRight || 'QUANTITY'}</span>

            {key === 'submit-later' && (
              <BoxesQuantityDropdown
                {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'submit-later-right')}
              />
            )}

            {key === 'without-power' && (
              <BoxesQuantityDropdown
                {...BOXES_QUANTITY_CONFIGS.find(config => config.key === 'without-right')}
              />
            )}
          </div>
        </div>
      </>
    );
  };

  const renderSubmitLater = () => {
    const isSamePower = selectedSubmitLater.isSamePower;

    return (
      <div className="contact-lens-select-power-and-boxes__submit-later">
        <div
          className="contact-lens-select-power-and-boxes__power-manually__container"
          data-is-same-power={isSamePower}
        >
          {isSamePower ? renderSameLeftAndRightEyes('submit-later') : renderEyes('submit-later')}
        </div>

        <div className="contact-lens-select-power-and-boxes__power-manually__same-power">
          <span
            data-is-checked={isSamePower}
            onClick={() =>
              setSelectedSubmitLater({ ...selectedSubmitLater, isSamePower: !isSamePower })
            }
          />
          <p>Same number of boxes for both eyes</p>
        </div>
      </div>
    );
  };

  const renderWithOrWithoutPower = () => {
    return (
      <div className="contact-lens-select-power-and-boxes__with-or-without-power">
        <a
          data-selected={selectedWithOrWithoutPower === 'without-power'}
          onClick={() => setSelectedWithOrWithoutPower('without-power')}
        >
          <span>WITHOUT POWER</span>
        </a>
        <a
          data-selected={selectedWithOrWithoutPower === 'with-power'}
          onClick={() => setSelectedWithOrWithoutPower('with-power')}
        >
          <span>WITH POWER</span>
        </a>
      </div>
    );
  };

  const renderPowerAndBoxes = () => {
    return (
      <ul className="contact-lens-select-power-and-boxes__list">
        {CONTACT_LENS_POWER_AND_BOXES_LIST.map(({ key, title }, i) => (
          <li
            key={key}
            className="contact-lens-select-power-and-boxes__item"
            data-selected={selectedPower === key}
            onClick={() => setSelectedPower(key)}
          >
            <span className="contact-lens-select-power-and-boxes__item-title">{title}</span>

            {selectedPower === 'use-saved-power' && i === 0 && renderPowerList()}
            {selectedPower === 'enter-power-manually' && i === 1 && renderPowerManually()}
            {selectedPower === 'i-will-submit-power-later' && i === 2 && renderSubmitLater()}
          </li>
        ))}
      </ul>
    );
  };

  const renderWithoutPower = () => {
    const isSamePower = selectedWithoutPower.isSamePower;

    return (
      <div className="contact-lens-select-power-and-boxes__without-power">
        <div
          className="contact-lens-select-power-and-boxes__without-power__container"
          data-is-same-power={isSamePower}
        >
          {isSamePower ? renderSameLeftAndRightEyes('without-power') : renderEyes('without-power')}
        </div>

        <div className="contact-lens-select-power-and-boxes__without-power__same-power">
          <span
            data-is-checked={isSamePower}
            onClick={() =>
              setSelectedWithoutPower({ ...selectedWithoutPower, isSamePower: !isSamePower })
            }
          />
          <p>Same number of boxes for both eyes</p>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (!hasWithOrWithoutPower) {
      return renderPowerAndBoxes();
    }

    return selectedWithOrWithoutPower === 'without-power'
      ? renderWithoutPower()
      : renderPowerAndBoxes();
  };

  return (
    <div className="contact-lens-select-power-and-boxes__container">
      <h3 className="contact-lens-select-power-and-boxes__title">Select power and boxes</h3>
      {hasWithOrWithoutPower && renderWithOrWithoutPower()}
      {renderContent()}

      {SELECT_POWER_CONFIGS.map(({ key, isOpen, value, eye, onClose, onSelect }) => (
        <SelectPowerModal
          key={key}
          eye={eye}
          isOpen={isOpen}
          value={value}
          onClose={onClose}
          onSelect={onSelect}
        />
      ))}

      {BOXES_QUANTITY_CONFIGS.map(({ key, isOpen, value, eye, onClose, onSelect }) => (
        <BoxesQuantityModal
          key={key}
          eye={eye}
          isOpen={isOpen}
          value={value}
          onClose={onClose}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};
